export default __webpack_public_path__ + "static/media/3.cac009a3.jpg";